import React from "react"

import CheckboxField from "./checkbox/CheckboxField"
import DateField from "./date/DateField"
import InlineAttachment from "./attachments/InlineAttachment"
import InlineButtonsField from "./inlineButtons/InlineButtonsField"
import ItemPicker from "./item-picker"
import LoadingPlaceholder from "./LoadingPlaceholder"
import LocationField from "./location/LocationField"
import MapField from "./map/MapField"
import NumberField from "./number/NumberField"
import RichTextField from "./rtf"
import Section from "./section/Section"
import TagField from "./tags/TagField"
import TextBigField from "./text/TextBigField"
import TextSmallField from "./text/TextSmallField"
import TimeField from "./time/TimeField"
import ToggleButtonField from "./toggle/ToggleButtonField"
import TreeSelectorComponent from "./treeSelector"
import { ItemRelation } from "./item-relation"
import {
    ICheckboxField,
    IDateField,
    IField,
    IInlineAttachmentField,
    IInlineButtonsField,
    IItemPickerField,
    IItemRelationField,
    ILocationField,
    IMapField,
    INumberField,
    IRichTextField,
    ISectionField,
    ITagPickerField,
    ITextField,
    ITimeField,
    IToggleButtonField,
    ITreeSelectorField,
} from "../index"

interface FieldProp {
    field?: IField
    isLoading: boolean
}

export const Field = ({ field, isLoading }: FieldProp): JSX.Element => {
    if (!field) {
        return <>{isLoading && <LoadingPlaceholder />}</>
    }
    switch (field.type) {
        case "smallText":
        case "longText":
            return <TextSmallField field={field as ITextField} />
        case "bigText":
            return <TextBigField field={field as ITextField} />
        case "selector": {
            return <TreeSelectorComponent {...(field as ITreeSelectorField)} />
        }
        case "itemPicker":
            return <ItemPicker {...(field as IItemPickerField)} />
        case "itemRelation":
            return <ItemRelation {...(field as IItemRelationField)} />
        case "tagPicker":
            return <TagField {...(field as ITagPickerField)} />
        case "time":
            return <TimeField field={field as ITimeField} />
        case "number":
            return <NumberField field={field as INumberField} />
        case "checkbox":
            return <CheckboxField field={field as ICheckboxField} />
        case "date":
            return <DateField field={field as IDateField} />
        case "toggle":
            return <ToggleButtonField field={field as IToggleButtonField} />
        case "richText":
            return <RichTextField field={field as IRichTextField} />
        case "map":
            return <MapField field={field as IMapField} />
        case "location":
            return <LocationField field={field as ILocationField} />
        case "section":
            return <Section field={field as ISectionField} />
        case "inlineAttachment":
            return <InlineAttachment field={field as IInlineAttachmentField} />
        case "inlineButtons":
            return <InlineButtonsField field={field as IInlineButtonsField} />

        default:
            return <></>
    }
}
